import styled from 'astroturf';
import React from 'react';

const Tabs = /*#__PURE__*/styled("ul", null, {
  displayName: "Tabs",
  styles: require("./Tabs.module.css"),
  attrs: null,
  vars: []
});

const Tab = /*#__PURE__*/styled('li', null, {
  displayName: "Tab",
  styles: require("./Tabs-Tab.module.css"),
  attrs: null,
  vars: []
});

export { Tab };
export default Tabs;
